import { classNames } from '@schuelerhilfe/shared/src/utils/classNames';
import type { SingleTextResolved, SingleTextStyle } from './types';
import { Text } from '@/lib/render/Text';

const ALIGNMENTS: Record<
  NonNullable<SingleTextResolved['alignment']>,
  string
> = {
  left: 'text-left',
  center: 'text-center',
  right: 'text-right',
};

// Maps to the tag set accepted by <Text>, so placeholder substitution
// (concept §6.5) runs uniformly on the editor-provided copy.
const STYLE_TAGS: Record<SingleTextStyle, 'p' | 'h1' | 'h2' | 'h3' | 'h4'> = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  body: 'p',
};

export function SingleTextComponent({
  resolved,
}: {
  resolved: SingleTextResolved;
}) {
  const { text, textStyle = 'body', alignment = 'left' } = resolved;
  if (!text) {
    return null;
  }
  const Tag = STYLE_TAGS[textStyle] ?? 'p';
  const alignmentClass = ALIGNMENTS[alignment] ?? ALIGNMENTS.left;
  return (
    <Text
      as={Tag}
      field="text"
      // `mb-0` cancels the base `p { margin-bottom: 16px }` in globals.css —
      // the widget root itself must carry no bottom spacing whatever tag it
      // renders as (see the spacing convention in CLAUDE.md).
      className={classNames('mb-0 pt-4', alignmentClass)}
    >
      {text}
    </Text>
  );
}
